

(function ($) {
    'use strict';
    $(function () {

        $(".js-dropdown-trigger").children().first().click(function (e) {
            console.log($(this).attr('href'));
            if ($(this).attr('href') == '#') {
                e.preventDefault();
                e.stopPropagation();
            }
        });


        $(".js-dropdown-trigger").hoverIntent({
            over: animateDropdownIn,
            out: animateDropdownOut,
            timeout: 300,
        });

        function animateDropdownIn(e) {
            $(this).find('.dropdown__menu').slideDown(150);
            $(this).addClass('dropdown--open');
            $('.js-menu').addClass('dropdown--open');
        }

        function animateDropdownOut(e) {
            $(this).find('.dropdown__menu').slideUp(150);
            $(this).removeClass('dropdown--open');
            $('.js-menu').removeClass('dropdown--open');
        }



        const mobilMenu = document.querySelector(".js-menu");

        $('.js-menu-open').on('click', function (e) {
            e.preventDefault();
            $('.js-menu').addClass('active');
            $('.js-menu-underlay').addClass('active');
            bodyScrollLock.disableBodyScroll(mobilMenu);
        })

        $('.js-menu-close,.js-menu-underlay').on('click', function (e) {
            e.preventDefault();
            $('.js-menu').removeClass('active');
            $('.js-menu-underlay').removeClass('active');
            bodyScrollLock.enableBodyScroll(mobilMenu);
        })

    });
})(jQuery);
